import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { Team } from '@/services/team'
import Cookies from 'js-cookie'

@Injectable()
export class VipModifyService {
  constructor (private http: Http, private team: Team) {
  }

  updateShowVip () {
    return this.http.post<void>('/team/update_show_vip', {}).then(res => {
      const teamInfo = JSON.parse(Cookies.get('currentTeam') || '{}')
      this.team.updateCurrentTeam({
        ...teamInfo,
        show_vip_modify: false,
      })
    })
  }
}
